import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdsenseService } from '../../../app/shared/services/adsense.service';
import { MonitoringService } from '../../../app/shared/services/monitoring.service';
import { SecurityService } from '../../../app/shared/services/security.service';
import { parseDecimal } from '../../../app/shared/utils/utils';
import { CustomValidators } from '../../../app/shared/validators/customValidations';
import { urlConfig } from '../../../config/url.config';
import { CLIENT_TYPE } from '../../shared/enum/tracking.enum';
import { BasePage } from '../../shared/model/base-page/base-page.model';
import { NormalizeImagePipe } from '../../shared/pipes/normalize-image.pipe';
import { HeaderService } from '../../shared/services/header.service';
import { ROUTES } from '../../shared/utils/routes';
import { StorageModule } from '../../shared/utils/storage.module';
import { CMS_RESPONSE } from '../mock/cms.mock';
import {
  ConsultationCpfcreditScoreTHModel,
  ConsultationCpfModel,
} from '../models/consultation-cpf.model';
import { CpfResponseModel } from '../models/cpf-response.model';
import { FooterModel } from '../models/footer.model';
import { HeaderModel } from '../models/header.model';
import { LandingModel } from '../models/landing.model';
import {
  getAdsense,
  setAdsense,
  setDocumento,
  setFlowId,
} from '../models/session-storage';
import { StartHttpService } from '../services/start-http.service';

declare var $: any;
@Component({
  selector: 'mob-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent
  extends BasePage
  implements OnInit, AfterViewInit
{
  public VoHeader: any;
  public VoFooter: any;
  public VO: any;
  public form: FormGroup;
  public formFooter: FormGroup;
  public formOfferCard: FormGroup;
  public formSubmitted: boolean = false;
  public offerCardFormSubmitted: boolean = false;
  public formFooterSubmitted: boolean = false;
  public isCookieAlertEnabled: boolean;
  private cookieAlertCloseAnimationTime = 300; //ms
  public cookieAlertDisplayStatus = 'visible';
  private adsense;
  public type = 'text/javascript';
  public endpointMob = '';
  public widthResize = 768;
  public endpointOpf = '';
  public endpointFopa = '';
  public width = window.innerWidth;
  public isMock: boolean;
  public normalizeImage = NormalizeImagePipe.prototype.transform;
  public showFloatingButton = false;

  @ViewChild('mainpanel') MainPanelComponent: any;

  //   /** CPF Form Control */
  get cpf() {
    return this.form.get('cpf');
  }
  //   /** CPF Form Control */
  get cpfFooter() {
    return this.formFooter.get('cpf');
  }

  get cpfOfferCard() {
    return this.formOfferCard.get('cpf');
  }

  reciveCpf($event) {
    this.cpf.setValue($event);
    this.formSubmitted = true;
    this.send('next-top');
  }

  @ViewChild('cpfElementTop') cpfElementTop: ElementRef;
  @ViewChild('cpfElementFooter')
  cpfElementFooter: ElementRef;

  constructor(
    public headerService: HeaderService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public startHttpService: StartHttpService,
    public securityService: SecurityService,
    public storage: StorageModule,
    private adsenseService: AdsenseService,
    private monitoringService: MonitoringService
  ) {
    super(storage, headerService, activatedRoute);

    if (activatedRoute) {
      activatedRoute.queryParams.subscribe((params) => this.saveAdense(params));
    }

    this.endpointMob = urlConfig.url_mob;
    this.endpointOpf = urlConfig.url_opf;
    this.endpointFopa = urlConfig.url_fopa;
  }

  ngOnInit() {
    this.monitoringService.send('landing');
    this.buildView();
    this.buildForm();
    this.buildValidation();
    const cookieAlertStatus = this.storage.get('isCookieAgreed');
    this.isCookieAlertEnabled = cookieAlertStatus ? false : true;
    this.monitoringService.removeStorageDatalayer();
  }

  ngAfterViewInit() {
    const floatbutton = this.storage.getBtnFloatFlag();
    this.showFloatingButton = floatbutton === 'Y' ? true : false;
  }

  disableCookieAlert() {
    this.storage.put('isCookieAgreed', '1');
    this.cookieAlertDisplayStatus = 'invisible';
    setTimeout(() => {
      this.isCookieAlertEnabled = false;
    }, this.cookieAlertCloseAnimationTime);
  }

  buildView() {
    const routeData = this.activatedRoute.snapshot.data;
    this.isMock = routeData.cmsPage.step ? false : true;
    if (!this.isMock) {
      console.log(routeData.cmsPage.step);
      this.VoHeader = new HeaderModel(routeData.cmsPage.step);
      this.VO = new LandingModel(routeData.cmsPage.step);

      this.VoFooter = new FooterModel(routeData.cmsPage.step);
    } else {
      this.VoHeader = new HeaderModel(CMS_RESPONSE);
      this.VO = new LandingModel(CMS_RESPONSE);

      this.VoFooter = new FooterModel(CMS_RESPONSE);
    }
    this.headerService.hide();
    this.headerService.showBackButton = false;
  }

  buildValidation() {
    this.cpf.setValidators([Validators.required, CustomValidators.invalidCPF]);

    this.cpfFooter.setValidators([
      Validators.required,
      CustomValidators.invalidCPF,
    ]);

    this.cpfOfferCard.setValidators([
      Validators.required,
      CustomValidators.invalidCPF,
    ]);
  }

  buildForm() {
    this.form = new FormGroup({
      cpf: new FormControl(''),
    });

    this.formFooter = new FormGroup({
      cpf: new FormControl(''),
    });

    this.formOfferCard = new FormGroup({
      cpf: new FormControl(''),
    });
  }

  public send(payload) {
    const { action } = payload;
    let document = '';

    if (action === 'next-footer') {
      this.formFooterSubmitted = true;
      this.formSubmitted = false;
      this.offerCardFormSubmitted = false;
    }

    if (action === 'next-top') {
      this.formSubmitted = true;
      this.formFooterSubmitted = false;
      this.offerCardFormSubmitted = false;
    }

    if (action === 'next-middle') {
      this.formSubmitted = false;
      this.formFooterSubmitted = false;
      this.offerCardFormSubmitted = true;
    }

    if (this.formFooterSubmitted) {
      if (!this.formFooter.invalid) {
        const doc = this.formFooter.get('cpf').value;
        this.sendDocument(doc);
      } else {
        this.cpfElementFooter.nativeElement.focus();
      }
    }

    if (this.formSubmitted) {
      if (!this.form.invalid) {
        const doc = this.form.get('cpf').value;
        this.sendDocument(doc);
      } else {
        this.cpfElementTop.nativeElement.focus();
      }
    }

    if (this.offerCardFormSubmitted) {
      if (!this.formOfferCard.invalid) {
        const doc = this.formOfferCard.get('cpf').value;
        this.sendDocument(doc);
      }
    }
  }

  async sendDocument(document) {
    const adsense = getAdsense();
    this.clearStorage();
    setAdsense(adsense);
    sessionStorage.setItem('document', document);
    setDocumento(parseDecimal(document));

    this.headerService.isPageLoading = true;
    this.headerService.loadingTextTitle = 'Carregando';

    const cpfEncrypt = this.securityService.encrypt(parseDecimal(document));
    const consultationCpfModel = new ConsultationCpfModel(cpfEncrypt);
    const consultationCpfcreditScoreTHModel =
      new ConsultationCpfcreditScoreTHModel(cpfEncrypt);

    await this.startHttpService
      .sendCPFcreditScoreTH(consultationCpfcreditScoreTHModel)
      .subscribe(
        (response) => {
          this.monitoringService.sendCheckStatusTH(response, 'contacartao');
        },
        (error: any) => {
          console.error(error);
        }
      );

    await this.startHttpService.sendCPF(consultationCpfModel).subscribe(
      (response) => {
        this.handleSucess(response, cpfEncrypt);
      },
      (error: any) => {
        this.handleError(error);
      }
    );
  }

  handleSucess(response, cpfEncrypt) {
    const objectTest = new CpfResponseModel(response);
    setFlowId(objectTest.idflow);

    let flowId;
    switch (objectTest.idflow) {
      case 1:
        flowId = 'OPEN';
        break;
      case 10:
        flowId = 'MONO';
        break;
      case 2:
        flowId = 'CARD';
        break;
      case 5:
        flowId = 'FOPA';
        break;
      default:
        break;
    }

    this.monitoringService.customEvent({
      dimension8: cpfEncrypt,
      dimension33: CLIENT_TYPE[flowId],
      dimension68: CLIENT_TYPE[flowId],
    });

    setTimeout(() => {
      setTimeout(() => {
        if (objectTest && objectTest.application === 'MOB') {
          objectTest.seturlRedirect(this.endpointMob);
          window.location.href = objectTest.urlRedirect;
        } else if (objectTest && objectTest.application === 'OPF') {
          objectTest.seturlRedirect(this.endpointOpf);
          window.location.href = objectTest.urlRedirect;
        } else if (objectTest && objectTest.application === 'FOPA') {
          objectTest.seturlRedirect(this.endpointFopa);
          window.location.href = objectTest.urlRedirect;
        } else if (objectTest && objectTest.accountHolder) {
          sessionStorage.removeItem('errorDetail');
          this.router.navigate([ROUTES.errorAccountHolder.url]);
        } else if (objectTest && objectTest.haveRestrictive) {
          sessionStorage.removeItem('errorDetail');
          this.router.navigate([ROUTES.errorAccountRejected.url]);
        }
      }, 1000);
    }, 1000);
  }

  saveAdense(paramsQuery: any) {
    this.adsense = this.adsenseService.getParametersAdsense(paramsQuery);
    this.adsense && this.adsenseService.storeAdsense(this.adsense);
  }

  handleError(error) {
    sessionStorage.setItem('errorDetail', JSON.stringify(error));
    this.router.navigate([ROUTES.errorGeneric.url]);
  }

  public isMobileOrDesk() {
    if (window.innerWidth <= this.widthResize) {
      return true;
    }
    return false;
  }
  validate() {
    this.send({});
  }

  getFlowDimension(idflow) {
    return idflow === 10
      ? 'monoprodutista'
      : idflow === '2'
      ? 'card'
      : 'mar-aberto';
  }

  sendTag($event) {
    this.monitoringService.click('link:clique-aqui');
  }

  private clearStorage() {
    this.storage.clear();
  }
}
